export default __webpack_public_path__ + "static/media/secure.fbc1b9d1.svg";